export enum PositionOpenReasonType {

    UserRequest = 1,
}
